module.exports = __webpack_public_path__ + "static/media/message-all.94001462.svg";